export const orgRoleColors = {
  admin: ['pink', 'lighten-4'],
  organizer: ['green', 'lighten-3'],
  member: ['orange', 'lighten-4']
};

export const groupRoleColors = {
  all: ['orange', 'lighten-4']
};
